module.exports = __webpack_public_path__ + "static/onion_r-de8e029c6b75f10de2e6b1e838f34de0.png";